import Vue from 'vue'
import locale from 'element-ui/lib/locale'
import ja from 'element-ui/lib/locale/lang/ja'
import ElementUi from 'element-ui'

Vue.use(ElementUi)
locale.use(ja)
